import { Component } from '@angular/core';

@Component({
  selector: 'app-sedi',
  imports: [],
  templateUrl: './sedi.component.html',
  styleUrl: './sedi.component.css'
})
export class SediComponent {

  mailFonte: string = 'info.laurentina@fullmuscle.eu';
  mailTrigoria: string = 'info.trigoria@fullmuscle.eu';
}
